import React, { memo, useEffect, useState } from 'react';
import { TYPE } from '../../constant';
import useHackleInfo from '../../hooks/useHackle';
import Button from './Button';

const EXPERIMENT_KEY = 9;

const HackleNoteBtn = memo((props) => {
    const [ key, setKey ] = useState(null);

    const { info : hackleInfo  } = useHackleInfo();
    const getHackle = hackleInfo?.INIT_ONBOARDING;

    // test
    // props.hackleInfo.globalInfo.language = "en";
    // props.hackleInfo.globalInfo.variation = "A"; 
    // props.hackleInfo.globalInfo.deviceType = TYPE.DEVICE.PHONE;
    
    const conditionA = (getHackle?.variation === "A" && getHackle?.deviceType === TYPE.DEVICE.PHONE && props.location === 'viewer');
    const conditionB = (getHackle?.variation === "B" && getHackle?.deviceType === TYPE.DEVICE.PHONE && props.location === 'inputer');
    const conditionC = (getHackle?.variation === "C" && getHackle?.deviceType === TYPE.DEVICE.PHONE && props.location === 'viewer');

    useEffect(() => {
        // console.log("hackleInfo", hackleInfo?.INIT_ONBOARDING);

        const key = getHackle?.key || null;
        setKey(key === EXPERIMENT_KEY && EXPERIMENT_KEY);

    }, [hackleInfo]);
    return (
        key === EXPERIMENT_KEY ? (
            <>
            { getHackle?.language === 'ko' && props.location === 'viewer' && <Button className="note_btn">연습장</Button> }
            { getHackle?.language === 'en' && props.location === 'viewer' && getHackle?.deviceType !== TYPE.DEVICE.PHONE && <Button className="note_btn">연습장</Button>}
            { getHackle?.language === 'en' && conditionA && <Button className="note_btn">연습장</Button> }
            { getHackle?.language === 'en' && conditionB && <div className="ask_area pos" style={{ right : 'auto' }}><Button className="note_btn2 blue" onClick={props.onSelect}/></div>}        { 
                getHackle?.language === 'en' && conditionC && 
                <Button className="btn_ab_test" style={{
                    zIndex: '25'
                    }}>
                    <span className="tap">TAP</span>
                    <span>Notepad</span>
                </Button> 
            }
            </>
        ) : props.location === 'viewer' && <Button className="note_btn">연습장</Button>
    );
});

export default HackleNoteBtn;